// Dynamic tracking pixel injector
// Facebook Pixel, TikTok Pixel, Google Ads conversion, Google Analytics GA4

let injected = { fb: false, tt: false, gads: false, ga: false };

export function injectPixels({ facebook_pixel_id, tiktok_pixel_id, google_ads_id, google_analytics_id }) {
  if (typeof window === 'undefined') return;

  // Facebook Pixel
  if (facebook_pixel_id && !injected.fb) {
    injected.fb = true;
    /* eslint-disable */
    !function(f,b,e,v,n,t,s){if(f.fbq)return;n=f.fbq=function(){n.callMethod?
      n.callMethod.apply(n,arguments):n.queue.push(arguments)};if(!f._fbq)f._fbq=n;
      n.push=n;n.loaded=!0;n.version='2.0';n.queue=[];t=b.createElement(e);t.async=!0;
      t.src=v;s=b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t,s)}(window,
      document,'script','https://connect.facebook.net/en_US/fbevents.js');
    window.fbq('init', facebook_pixel_id);
    window.fbq('track', 'PageView');
    /* eslint-enable */
  }

  // TikTok Pixel
  if (tiktok_pixel_id && !injected.tt) {
    injected.tt = true;
    /* eslint-disable */
    !function (w, d, t) {
      w.TiktokAnalyticsObject=t;var ttq=w[t]=w[t]||[];ttq.methods=["page","track","identify","instances","debug","on","off","once","ready","alias","group","enableCookie","disableCookie","holdConsent","revokeConsent","grantConsent"],
      ttq.setAndDefer=function(t,e){t[e]=function(){t.push([e].concat(Array.prototype.slice.call(arguments,0)))}};
      for(var i=0;i<ttq.methods.length;i++)ttq.setAndDefer(ttq,ttq.methods[i]);
      ttq.instance=function(t){for(var e=ttq._i[t]||[],n=0;n<ttq.methods.length;n++)ttq.setAndDefer(e,ttq.methods[n]);return e};
      ttq.load=function(e,n){var r="https://analytics.tiktok.com/i18n/pixel/events.js",o=n&&n.partner;ttq._i=ttq._i||{},ttq._i[e]=[],ttq._i[e]._u=r,ttq._t=ttq._t||{},ttq._t[e]=+new Date,ttq._o=ttq._o||{},ttq._o[e]=n||{};n=document.createElement("script");n.type="text/javascript",n.async=!0,n.src=r+"?sdkid="+e+"&lib="+t;e=document.getElementsByTagName("script")[0];e.parentNode.insertBefore(n,e)};
      ttq.load(tiktok_pixel_id);
      ttq.page();
    }(window, document, 'ttq');
    /* eslint-enable */
  }

  // Google Analytics (GA4) and/or Google Ads use gtag.js
  const gaNeeded = !!(google_ads_id || google_analytics_id);
  if (gaNeeded && !injected.ga) {
    injected.ga = true;
    const idForScript = google_analytics_id || google_ads_id;
    const s = document.createElement('script');
    s.async = true;
    s.src = `https://www.googletagmanager.com/gtag/js?id=${idForScript}`;
    document.head.appendChild(s);
    window.dataLayer = window.dataLayer || [];
    window.gtag = function () { window.dataLayer.push(arguments); };
    window.gtag('js', new Date());
    if (google_analytics_id) window.gtag('config', google_analytics_id);
    if (google_ads_id) window.gtag('config', google_ads_id);
  }
}

export function trackPixelEvent(eventName, params = {}) {
  try { window.fbq && window.fbq('track', eventName, params); } catch {}
  try {
    const ttEvent =
      eventName === 'Lead' ? 'SubmitForm' :
      eventName === 'Subscribe' ? 'Subscribe' :
      eventName === 'CompleteRegistration' ? 'CompleteRegistration' :
      'ClickButton';
    window.ttq && window.ttq.track && window.ttq.track(ttEvent, params);
  } catch {}
  try { window.gtag && window.gtag('event', eventName, params); } catch {}
}
